/*
   Bu sayfa minio->huawei dosya süreçlerinin prod ortam testleri için oluşturulmuştur.
   Prod ortamda kontroller sonrası kaldırılacaktır.
*/

import { useAuth, useAirborneAppConfig } from "@airborne/react-admin";
import { Card, Divider, Grid, TextField, makeStyles } from "@material-ui/core";
import { CloudDownload, CloudUpload } from "@material-ui/icons";
import * as React from "react";
import { Button, useNotify } from "react-admin";
import { SectionTitle } from "../../../Components/SectionTitle";
import { Separator } from "../../../Components/Separator";
import { useAppDataProvider } from "../../../dataprovider";

const useStyles = makeStyles(theme => ({
  toolbar: {
    display: "flex",
    justifyContent: "flex-start",
    gap: "16px",
  },
  gridItem: {
    margin: "0px 10px",
  },
}));

export const FileTransfer = props => {
  const classes = useStyles(props);
  const dataProvider = useAppDataProvider();
  const { apiBaseUrl } = useAirborneAppConfig();
  const { tokens } = useAuth();
  const notify = useNotify();

  const fileInputRef = React.useRef<HTMLInputElement>(null);
  const [objectKey, setObjectKey] = React.useState("");
  const [uploading, setUploading] = React.useState(false);
  const [downloading, setDownloading] = React.useState(false);

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileSelected = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) {
      return;
    }
    setUploading(true);
    const formData = new FormData();
    formData.append("file", file);
    dataProvider
      .post("minio", formData)
      .then(({ data: { objectKey: uploadedObjectKey } }: any) => {
        setObjectKey(uploadedObjectKey);
        notify(`File uploaded successfully. Object key: ${uploadedObjectKey}`, { type: "success" });
      })
      .catch(() => {
        notify("File upload failed.", { type: "error" });
      })
      .finally(() => setUploading(false));
  };

  const handleDownloadClick = () => {
    if (!objectKey) {
      notify("Please enter an object key to download.", { type: "warning" });
      return;
    }
    setDownloading(true);
    fetch(`${apiBaseUrl}/minio/download/${objectKey}?token=${tokens?.accessToken}`)
      .then(response => {
        if (!response.ok) {
          throw new Error("Download failed");
        }
        return response.blob();
      })
      .then(blob => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.download = objectKey;
        link.href = url;
        link.click();
        URL.revokeObjectURL(url);
      })
      .catch(() => {
        notify("File download failed.", { type: "error" });
      })
      .finally(() => setDownloading(false));
  };

  return (
    <Card style={{ padding: "15px" }}>
      <Grid container spacing={0}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <SectionTitle label="File Transfer" />
          <Divider />
          <Separator />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} className={classes.gridItem}>
          <TextField
            label="Object Key"
            value={objectKey}
            onChange={e => setObjectKey(e.target.value)}
            fullWidth
            variant="outlined"
          />
        </Grid>
      </Grid>
      <Separator />
      <div className={classes.toolbar}>
        <input type="file" ref={fileInputRef} style={{ display: "none" }} onChange={handleFileSelected} />
        <Button
          label={uploading ? "Uploading..." : "File Upload"}
          size="medium"
          variant="contained"
          color="primary"
          disabled={uploading}
          onClick={handleUploadClick}
        >
          <CloudUpload />
        </Button>
        <Button
          label={downloading ? "Downloading..." : "File Download"}
          size="medium"
          variant="contained"
          color="primary"
          disabled={downloading}
          onClick={handleDownloadClick}
        >
          <CloudDownload />
        </Button>
      </div>
    </Card>
  );
};

export default FileTransfer;
